module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00046.7eeef1ed.jpg";